<template>
  <div class="todo-toolbar">
    <h2>功能菜单</h2>
    <!-- 添加搜索框 -->
    <div class="search-container">
      <input type="text" v-model="searchQuery" placeholder="搜索任务..." class="search-input" @input="handleSearch" />
    </div>
    <div class="toolbar-buttons">
      <button class="btn primary" @click="addTask">
        <i class="icon">+</i> 添加任务
      </button>
      <button class="btn secondary" @click="openSettings">
        <i class="icon">⚙️</i> 设置
      </button>
      <button v-if="userType === 1" class="btn secondary" @click="openFundDeduction">
        <i class="icon">💰</i> 基金消耗
      </button>
    </div>

    <!-- 基金消耗模态框 -->
    <FundDeductionModal v-if="showFundDeductionModal" @close="closeFundDeduction" />
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useTodoStore } from '../stores/todoStore.js'
import FundDeductionModal from './FundDeductionModal.vue'
import AuthService from '@/services/authService.js'

export default {
  name: 'TodoToolbar',
  components: {
    FundDeductionModal
  },
  setup() {
    const store = useTodoStore()
    const searchQuery = ref(store.searchQuery || '')

    // 获取当前用户类型
    const currentUser = AuthService.getCurrentUser();
    const userType = ref(currentUser ? currentUser.userType : 10);

    // 控制基金消耗模态框显示
    const showFundDeductionModal = ref(false)

    // 监听搜索框的变化并更新store
    watch(searchQuery, (newQuery) => {
      store.searchQuery = newQuery
    })

    // 监听store中搜索查询的变化并更新本地ref
    watch(() => store.searchQuery, (newQuery) => {
      searchQuery.value = newQuery || ''
    })

    const addTask = () => {
      store.openAddTaskModal()
    }

    const openSettings = () => {
      store.openSettingsModal()
    }

    // 打开基金消耗模态框
    const openFundDeduction = () => {
      showFundDeductionModal.value = true
    }

    // 关闭基金消耗模态框
    const closeFundDeduction = () => {
      showFundDeductionModal.value = false
    }

    return {
      searchQuery,
      userType,
      showFundDeductionModal,
      addTask,
      openSettings,
      openFundDeduction,
      closeFundDeduction
    }
  }
}
</script>

<style scoped>
.todo-toolbar {
  padding: 20px;
}

.search-container {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
  padding: 10px 15px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.search-input:focus {
  outline: none;
  border-color: #42b983;
}

.toolbar-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}

.btn {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.btn.primary {
  background: #42b983;
  color: white;
}

.btn.primary:hover {
  background: #359c6d;
}

.btn.secondary {
  background: #f0f0f0;
  color: #333;
}

.btn.secondary:hover {
  background: #e0e0e0;
}

.icon {
  font-size: 18px;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .todo-toolbar {
    padding: 15px;
  }

  .btn {
    padding: 10px 15px;
    font-size: 14px;
  }

  .icon {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .todo-toolbar {
    padding: 10px;
  }

  .search-input {
    font-size: 16px;
    /* 防止iOS缩放 */
    padding: 8px 12px;
  }

  .btn {
    padding: 12px;
    font-size: 14px;
  }
}
</style>